import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../../_services/reports.service';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { ExcelService } from 'src/app/_services/excel.service';
import * as _ from 'underscore';
import * as __ from 'lodash';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import * as FusionCharts from 'fusioncharts';
import TimeSeries from 'fusioncharts/viz/timeseries';
import FusionTheme from 'fusioncharts/themes/es/fusioncharts.theme.fusion';
import moment from 'moment';

@Component({
    selector: 'app-personal-reports',
    templateUrl: './personal-reports.component.html',
    styleUrls: ['./personal-reports.component.scss'],
    providers: [ExcelService],
    standalone: false
})
export class PersonalReportsComponent implements OnInit {
  activityTableHeader = ['Name', 'Active \n Days', 'Searches \n Performed', 'Projects \n Created', 'Profiles\n Viewed', 'Contact \n Revealed', 'Credits \n Used', 'Profiles Added \n to Pipeline', 'Mails \n Sent']
activityDataList = [
  
]

  activeDays: number = 0
  averageContactsRevealed: number = 0
  averageProfileViewed: number = 0
  averageSearchPerformed: number = 0
  chartData: any = {}
  creditData: any = {}
  width = "100%";
  height = 400;
  type = "line";
  firstName: any;
  lastName: any;
  reportType: any;
  activitySelected: any = "searches-performed"
  userid: any;
  currentCredit: number = 0;
  
  constructor(private reportService: ReportsService, private localStorageService: LocalStorageService, private excel:ExcelService, private router:Router, private datePipe: DatePipe) { 
    this.firstName = this.localStorageService.getItem('ufname')
    this.lastName = this.localStorageService.getItem('ulname')
  }
 




  ngOnInit(): void {
   
    this.userid = this.localStorageService.getItem('userid')
    this.reportService.fetchDataWithDate().subscribe((event: any)=> {

      if(this.router.url.includes('personal')){
        this.activitySelected = 'searches-performed';
        this.updateAllReports()
      }
    });
    this.resetchartData();
    this.resetCreditData();
    // this.chartData = {
    //   chart: {
    //     // caption: `Total number of ${this.reportType} over the selected date range`,
    //     // showvalues: "0",
    //     // numvisibleplot: "6",
    //     plottooltext:
    //       `<b>$dataValue</b> Totdal number of ${this.reportType} over the selected date range $label`,
    //     // theme: "candy"    
    //     "theme": "fusion",
    //     labelstep:1
    //   },
    //   // categories: [
    //   //   {
    //   //     category: [
            
    //   //     ]
    //   //   }
    //   // ],    
    //   // dataset: [
    //   //   {
    //   // data: [],
    //   //   }
    //   // ]

    //   data: []
    // };



    // this.creditData = {
    //   chart: {
    //     // caption: "Credit",
    //     showvalues: "0",
    //     numvisibleplot: "6",
    //     legendposition: "top",
 
    //     "showSum": "1",
    //     plottooltext:
    //       "<b>$dataValue</b> $seriesName $label",
    //     // theme: "candy"    
    //     "theme": "fusion",
    //     "paletteColors": "#d9d9ff, #8585dd",
    //   },
    //   categories: [
    //     {
    //       category: [
            
    //       ]
    //     }
    //   ],    
    //   dataset: [
    //     {
    //   data: [],
    //     }
    //   ]
    // };
  

    this.getAllCount();
    this.getActivityDetails();
    this.getActivityBreakdown()
    this.getCreditUsage();
  }


  getAllCount(){
  
    const data = {
      startdate: localStorage.getItem('startDate'),
      enddate: localStorage.getItem('endDate'),
      reporttype: 'personal',
    }

    this.reportService.getAllReportsCount(data).subscribe((result: any) => {
      if(result && result.status == 'success' && result.message && result.message.activeDays > 0){

        this.activeDays =  result.message.activeDays ? result.message.activeDays : 0;
        this.averageContactsRevealed = result.message.averageContactsRevealed ? result.message.averageContactsRevealed : 0;
        this.averageProfileViewed = result.message.averageProfileViewed ? result.message.averageProfileViewed : 0;
        this.averageSearchPerformed = result.message.averageSearchPerformed ? result.message.averageSearchPerformed : 0;
    
      }else{
        this.activeDays = 0;
        this.averageContactsRevealed = 0;
        this.averageProfileViewed = 0;
        this.averageSearchPerformed = 0;
      }
     
    });
  }

  getActivityBreakdown(){
    const data = {
      startdate: localStorage.getItem('startDate'),
      enddate: localStorage.getItem('endDate'),
      reporttype: 'personal',
    }

    this.reportService.getActivityBreakDown(data).subscribe((result: any) => {
      if(result && result.status == 'success' && result.message){
        this.activityDataList = []
        
        const actvity = result.message
        this.activityDataList.push({
          name: this.firstName + " " + this.lastName,
          acitvedays: actvity.activeDays ? actvity.activeDays : 0,
          searchperformed: actvity.totalSearch ? actvity.totalSearch : 0,
          talentpoolcreated: actvity.totalProjectCreated ? actvity.totalProjectCreated : 0,
          profilesviewed: actvity.totalProfileViewed ? actvity.totalProfileViewed : 0,
          contactrevealed: actvity.totalContactRevealed ? actvity.totalContactRevealed : 0,
          creditsused: actvity.totalCreditsUsed ? actvity.totalCreditsUsed : 0,
          profilesaddedtotalentpool: actvity.totalProfileAddedToTalentpool ? actvity.totalProfileAddedToTalentpool : 0,
          mailssent: actvity.totalMailsSent ? actvity.totalMailsSent : 0
   
        })
      }
    });
  }

  getActivityDetails(event: any = null) {
    const data = {
      startdate: localStorage.getItem('startDate'),
      enddate: localStorage.getItem('endDate'),
      activitytype: event?.target?.value ? event.target.value : 'searches-performed',
      reporttype: 'personal',
    }

    if(data.activitytype == 'searches-performed'){
      this.reportType = "Searches Performed"
    }else if(data.activitytype == 'active-days'){
      this.reportType = "Active Days"
    }else if(data.activitytype == 'profile-viewed'){
      this.reportType = "Profile Viewed"
    }else if(data.activitytype == 'contacts-revealed'){
      this.reportType = "Contacts Revealed"
    }

    this.reportService.getActivityDetails(data).subscribe((result: any) => {
      this.resetchartData();
      if(result.status == 'success' && result.message && result.message.length){
        // result.message.forEach((item, index) => {
          let aa = []
          // console.log()
          result.message.forEach((item) => {
  
            let parsedDate = moment(item.activedays);
            // console.log(item.activedays, 'item.acitvedaysitem.acitvedays')
            // Format the date as per your requirement
            let formattedDate = parsedDate.format('M/D/YYYY');
            
            // this.chartData.data.push([ new Date(item.activedays).toISOString().split('T')[0], item.userscount ]);
            aa.push([ formattedDate, item.userscount ]);
  
            // %-m/%-d/%Y convert to moment format
            // const moment_format = 'm'

         
            // const URL_DATA = 'https://raw.githubusercontent.com/fusioncharts/dev_centre_docs/master/assets/datasources/fusiontime/examples/online-sales-single-series/data.json';
            // const URL_SCHEMA = 'https://raw.githubusercontent.com/fusioncharts/dev_centre_docs/master/assets/datasources/fusiontime/examples/online-sales-single-series/schema.json';
  
            // const jsonify = res => res.json();
            // const dataFetch = fetch(URL_DATA).then(jsonify);
            // const schemaFetch = fetch(URL_SCHEMA).then(jsonify);
  
  
            // console.log(this.chartData, "this.chartData")
            // this.chartData.labelstep = this.calculateLabelStepBasedOnSelectedDays(result.message.length)
  
            // this.chartData.categories[0].category.push({
            //   label: new Date(item.activedays).toISOString().split('T')[0], // Format the date
  
            // })
           
          });

          // console.log(aa, 'aaaa')

            
        let timelineSearches = 'Total number of '

        let typee = ''
        if(data.activitytype == 'searches-performed'){
          this.reportType = "Searches Performed"
        }else if(data.activitytype == 'active-days'){
          this.reportType = "Active Days"
        }else if(data.activitytype == 'profile-viewed'){
          this.reportType = "Profile Viewed"
        }else if(data.activitytype == 'contacts-revealed'){
          this.reportType = "Contacts Revealed"
        }

          // "2023-11-25
          const all =[
            {
                "name": "Time",
                "type": "date",
                "format": "%-m/%-d/%Y",
                // "format": "%Y/%-m/%-d"
            },
            {
                "name": timelineSearches + this.reportType,
                "type": "number"
            }
          ]
        // schema[1].name = 
          // console.log(new FusionCharts.DataStore().createDataTable(aa, all), "new FusionCharts.DataStore().createDataTable(aa, all);new FusionCharts.DataStore().createDataTable(aa, all);")
          this.chartData.data = new FusionCharts.DataStore().createDataTable(aa, all);;

  
          console.log(this.chartData, 'this.chartDatathis.chartData')
  
      
        // }

        // });
      // });
    }
    });

      

  
    
    
  }

  

  updateAllReports(){
    
    this.getAllCount();
    this.getActivityDetails();
    this.getActivityBreakdown();
    this.getCreditUsage();
  }


  downloadReport(){
    let downloadobj = [];
    
    let headers = `Name,Active days,Searches performed, Projects Created, Profiles viewed,Contact revealed,Credits used,Profiles added to Pipeline,Mails sent`;
    let filename = "Reports"

    this.activityDataList.forEach(data => {
      let candidatelistobj = {};
      let headersmain = headers.split(",");

      headersmain.forEach((headers, index) => {
        let headersbe = headers
          .split(" ")
          .join("")
          .toLowerCase();

        //  acitvedays:10, searchperformed:10,talentpoolcreated:10,profilesviewed:10, contactrevealed:10,creditsused:10,profilesaddedtotalentpool:10,mailssent:10},

        if (headersbe == "name") {
          if (data["name"] != null) {
            candidatelistobj[headers] = data["name"];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == "activedays") {
          if (data["acitvedays"] != null) {
            candidatelistobj[headers] = data["acitvedays"];
          } else {
            candidatelistobj[headers] = 0;
          }
        }else if(headersbe == "searchesperformed"){
          if (data["searchperformed"] != null) {
            candidatelistobj[headers] = data["searchperformed"];
          } else {
            candidatelistobj[headers] = 0;
          }
        } else if (headersbe == "projectscreated") {
          candidatelistobj[headers] = data["talentpoolcreated"] != null ? data["talentpoolcreated"] : 0;
        } else if (headersbe == "profilesaddedtopipeline") {
          candidatelistobj[headers] = data["profilesaddedtotalentpool"] != null ? data["profilesaddedtotalentpool"] : 0;
        }else {
          if (data[headersbe] != null) {
            candidatelistobj[headers] = data[headersbe];
          } else {
            candidatelistobj[headers] = 0;
          }
        }
      });
      if (!_.isEmpty(candidatelistobj)) {
        downloadobj.push(candidatelistobj);
      }
    });

    let newobj = [];
    downloadobj.forEach(element => {
      newobj.push(Object.values(element));
    });

    this.excel.exportAsExcelFile(
      newobj,
      filename,
      headers.split(","),
      null
    );
  }

  getCreditUsage(){
    const data = {
      startdate: localStorage.getItem('startDate'),
      enddate: localStorage.getItem('endDate'),
      reporttype: 'personal',
    }

    this.reportService.getCreditUsage(data).subscribe((result: any) => {
      if(result && result.status == 'success' && result.message && result.message.length){
        this.resetCreditData();
        let a = this.localStorageService.getItem('userdata',)
 
       //  console.log(a, 'aa')
        this.currentCredit = a.balancebasiccontactenrichmentcredits
       
        let credit = result.message.find(obj => obj[this.userid])[this.userid]
       
         let totalCreditUsed = 0
         credit.forEach(val => {
           let tempCred = {}
         
           tempCred = {
             showvalues: "0",
             
             renderas: "area",
           }
           tempCred['label'] = val.enrichedfrom
           tempCred['value'] = val.credit_consumed
        
 
           if(val.enrichedfrom == 'pdl'){
             tempCred['color'] = "#ffe3c4"
           }else if(val.enrichedfrom == 'pipl'){
             tempCred['color'] = "#a3a3f7"
           }else if(val.enrichedfrom == 'nymblr'){
             tempCred['color'] = "#95e1d3"
           }else if(val.enrichedfrom == 'rocketreach'){
             tempCred['color'] = "#ffa8a8"
           }
           totalCreditUsed = totalCreditUsed + val.credit_consumed
           this.creditData.data.push(tempCred)
         })
         
 
         this.creditData.chart.defaultCenterLabel = "Credits Used <br/> " + totalCreditUsed
 
         this.currentCredit = credit[0].balancebasiccontactenrichmentcredits
         this.renderComplete();
        
      }  
    });
  }


  resetchartData(){
    this.chartData = {
      // caption: `Total number of ${this.reportType} over the selected date range`,
      // showvalues: "0",
      // numvisibleplot: "",
      // plottooltext:
      //   `<b>$dataValue</b> Total number of ${this.reportType} over the selected date range $label`,
      // // theme: "candy"    
      // "theme": "fusion",
      // dataSource : {
      //   data: []
      // },
      // chart: {
      //   exportEnabled: 1
      // },
      // caption: {
      //   text: 'Online Sales of a SuperStore in the US'
      // },
      // yAxis: {
      //   "plot": {
      //     "value": "Sales",
      //     "type": "line"
      //   },
      // },
      // navigator: {
      //   enabled: 0 // Set enabled to 0 to hide the slider
      // },
      //    "extensions": {
      //       "customRangeSelector": {
      //           "enabled": "0"
      //       }
      //   }
      "theme": "fusion",
     
      
      navigator: {
        enabled: 0 // Set enabled to 0 to hide the slider
      },
      "extensions": {
        "customRangeSelector": {
            "enabled": "0"
        },
        "standardRangeSelector": {
          "enabled": "0"
      }
    },  
    "xAxis": {
      outputTimeFormat: {
        //year: "",
      
        // month: "%d %b %Y",
        day: "%d %b",
        //hour: "",
        //minute: "",
        //second: "",
        //millisecond: ""
      }
    },
    legend: {
      enabled: '0',
    },
      // data: null
      data: null
    }

    // categories: [
    //   {
    //     category: [
          
    //     ]
    //   }
    // ],    
    // dataset: [
    //   {
    // data: [],
    //   }
    // ]
    
  
// }
  }

  resetCreditData(){
    this.creditData = {
      chart: {
        centerLabelFontSize : "10",
        // caption: "Credit",
        // showvalues: "0",
        // numvisibleplot: "6",
        // "showSum": "1",
        // plottooltext:
          // "<b>$dataValue</b> $seriesName $label",
        // theme: "candy",    
        "theme": "fusion",
        // "paletteColors": "#95e1d3, #ffe3c4, #ffa8a8, #a3a3f7",
        defaultCenterLabel: "0",
        showToolTip: 0,
        showLabels:0,
        showValues:0,
        "use3DLighting": "0",
        "decimals": "0",
        "yAxisNameFontColor": '#2C2C2C',
        "animateClockwise": "1",
        "enableSmartLabels":"1",
        "manageLabelOverflow":"1",
        "useEllipsesWhenOverflow":"1",
        "legendAllowDrag": "0",
        // "theme": "fusion",
        // "legendWidth": "400",
        // "showLabels": "0",
        "showPercentValues": "0",
        // "showValues": "0",
        "formatNumberScale": "0",
        // "thousandSeparatorPosition": "2,3",
        "labelFont": "Poppins",
        "legendItemFont": "Poppins",

        legendWidth: "400",
        legendPosition: "bottom"
      },
      data: [],
    };
  }

  

  calculateLabelStepBasedOnSelectedDays(selectedDays) {
   
    // console.log(selectedDays, 'selectedDaysselectedDaysselectedDays')
    // let labelStep = 0;
    // if(selectedDays < 10){
    //   labelStep = 1
    // }else if(selectedDays > 140){
    //   labelStep = Math.ceil(selectedDays / 30); 
    // }

    // console.log(labelStep, 'labelSteplabelStep')
    // return labelStep;
    return 30;
  }
    


  // const data = [
  //   // Your data here
  // ];
  
  // // Sort the data by date
  // data.sort((a, b) => new Date(a.activedays) - new Date(b.activedays));
  
  // // Initialize objects to store grouped data
  // const weeklyData = {};
  // const monthlyData = {};
  // const yearlyData = {};
  
  // data.forEach(entry => {
  //   const date = new Date(entry.activedays);
  //   const year = date.getFullYear();
  //   const week = getWeekNumber(date);
  //   const month = date.getMonth() + 1;
  
  //   // Group by weeks
  //   const weekKey = `Year ${year}, Week ${week}`;
  //   weeklyData[weekKey] = (weeklyData[weekKey] || 0) + entry.userscount;
  
  //   // Group by months
  //   const monthKey = `Year ${year}, Month ${month}`;
  //   monthlyData[monthKey] = (monthlyData[monthKey] || 0) + entry.userscount;
  
  //   // Group by years
  //   const yearKey = `Year ${year}`;
  //   yearlyData[yearKey] = (yearlyData[yearKey] || 0) + entry.userscount;
  // });
  
  // // Helper function to get week number
  // function getWeekNumber(date) {
  //   const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  //   d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  //   const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  //   const weekNumber = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  //   return weekNumber;
  // }
  
  // // Print the grouped data
  // console.log("Weekly Data:");
  // console.log(weeklyData);
  
  // console.log("\nMonthly Data:");
  // console.log(monthlyData);
  
  // console.log("\nYearly Data:");
  // console.log(yearlyData);
  

  renderComplete(){
    // console.log($event, 'eventevent')
    let sum = 0;

    // Calculate the total values
    for (let i = 0; i < this.creditData.data.length; i++) {
      sum += parseInt(this.creditData.data[i].value);
    }

    // Find the percentage of each data object and assign to "displayValue" attribute
    for (let i = 0; i < this.creditData.data.length; i++) {
      const percent = (Math.round((this.creditData.data[i].value / sum * 100) * 10) / 10);

      this.creditData.data[i].displayvalue = `dewdew ${this.creditData.data[i].label}, ${this.creditData.data[i].value} (${percent}%)`;
      const label = this.convertToTitleCase(GlobalService.getProvidername(this.creditData.data[i].label));
      const formattedValue = `<span style="font-weight: bold; background:red" margin:100px>${this.creditData.data[i].value}</span>`;
      const formattedPercent = `(${percent}%)`;

      // Constructing the label with left and right alignment
      const fusionChartLabel = `
        <div style="display: flex; justify-content: space-between;">
          <div>${label}</div>
          <div>${formattedValue} ${formattedPercent}</div>
        </div>
      `;

      

      // console.log(fusionChartLabel, 'fusionChartLabelfusionChartLabelfusionChartLabel')
      // this.creditData.data[i].label = fusionChartLabel;

      this.creditData.data[i].label = `${this.convertToTitleCase(GlobalService.getProvidername(this.creditData.data[i].label))},        <b>${this.creditData.data[i].value}</b> (${percent}%)`;
      // this.creditData.data[i].label = `${this.convertToTitleCase(GlobalService.getProvidername(this.creditData.data[i].label))} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${formattedValue} (${percent}%)`;
    }

    // console.log(this.creditData, 'dwedewdewddew');

  }


  convertToTitleCase(stringName){
    if(stringName){
      stringName = stringName.toLowerCase().split(' ');
      for(let i = 0;i<stringName.length;i++){
        stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
      }
      return stringName.join(' ');
    }
  }


  getTooltipText(name: any){
    if(name){
      if(name.includes('Active')){
        return 'Total number of active days in the selected time frame.'
      }else if(name.includes('Searches')){
        return 'Total number of new searches performed during the selected time frame.'
      }else if(name.includes('Profiles\n Viewed')){
        return 'Total number of profiles a user clicks into and views in the selected time frame.'
      }else if(name.includes('Projects')){
        return 'Total number of new projects created during the selected time frame.'
      }else if(name.includes('Contact')){
        return 'Total number of contact successfully revealed during the selected time frame.'
      }else if(name.includes('Credits')){
        return 'Total contact coins consumed during the selected time frame.'
      }else if(name.includes('Profiles Added \n to Pipeline')){
        return 'Total number of profiles added to a pipeline during the selected time frame.'
      }else if(name.includes('Mails')){
        return 'Total emails sent during the selected time.'
      }
    }
    return ''
  }

}









